import { I18nMessages } from "./models";

// TODO: move to app-core
export const mergeI18nMsgs = (...msgs: I18nMessages[]): I18nMessages => {
  const finalMsgs: I18nMessages = {};

  msgs.forEach((msgsSet) => {
    Object.keys(msgsSet).forEach((key) => {
      finalMsgs[key] = msgsSet[key];
    });
  });

  return finalMsgs;
};
